import React from 'react';
import { useFormik } from 'formik';
import { Navigate } from 'react-router-dom';
import * as yup from 'yup';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import { ButtonRow, FormInput, Loader, useAuth, AuthLayout } from '@omnigenbiodata/ui';
import ROUTES from '../../../../core/constants/routes.constant';

function ResetPassword() {
  const { t } = useTranslation(['portal', 'validation']);
  const { forgotPasswordHasError, isBusy, forgotPassword, forgotPasswordEmail } = useAuth();

  const validationSchema = yup.object().shape({
    email: yup.string().required(t('emailRequired', { ns: 'validation' })),
  });

  const formik = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema,
    onSubmit: (values: any) => {
      forgotPassword(values.email);
    },
  });

  return (
    <>
      {forgotPasswordEmail && <Navigate to={ROUTES.authSubmitResetPassword} />}
      <AuthLayout
        title={t('resetPassword.title')}
        text={t('resetPassword.text')}
        hasError={forgotPasswordHasError}
        errorText={t('alerts.resetPasswordFailed.text')}
        errorTitle={t('alerts.resetPasswordFailed.title')}
        dmsa
      >
        <form onSubmit={formik.handleSubmit}>
          <Box mb={4}>
            <FormInput
              error={formik.errors.email}
              name="email"
              label={t('forms.email')}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              touched={formik.touched.email}
              value={formik.values.email}
            />
          </Box>
          <ButtonRow forwardColor="primary" forwardLabel={t('buttons.confirm')} buttonSize="large" />
        </form>
      </AuthLayout>
      <Loader isVisible={isBusy} label={t('loaders.check') as string} />
    </>
  );
}

export default ResetPassword;
